export default class SearchContext {
    constructor(options = {}) {
        this.postType = options.postType
        this.search = options.search;
        this.markerTypes = options.markerTypes;
    }

    getAll() {
        return {
            postType: this.postType,
            search: this.search,
            markerTypes: this.markerTypes
        }
    }
}
